/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cr_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it run my cron job?`)
};

const es_cr_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Ejecuta mi trabajo cron?`)
};

const de_cr_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Führt es meinen Cron-Job aus?`)
};

const nl_cr_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voert het mijn cron-taak uit?`)
};

const fr_cr_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exécute-t-il ma tâche cron ?`)
};

const it_cr_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esegue il mio lavoro cron?`)
};

const pt_br2_cr_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele executa meu trabalho cron?`)
};

const pt_cr_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele executa meu trabalho cron?`)
};

const ja_cr_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cronジョブを実行しますか？`)
};

const zh_cr_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它会运行我的 cron 任务吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cr_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cr_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cr_faq3_q", locale)
	if (locale === "en") return en_cr_faq3_q(inputs)
	if (locale === "es") return es_cr_faq3_q(inputs)
	if (locale === "de") return de_cr_faq3_q(inputs)
	if (locale === "nl") return nl_cr_faq3_q(inputs)
	if (locale === "fr") return fr_cr_faq3_q(inputs)
	if (locale === "it") return it_cr_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_cr_faq3_q(inputs)
	if (locale === "pt") return pt_cr_faq3_q(inputs)
	if (locale === "ja") return ja_cr_faq3_q(inputs)
	return zh_cr_faq3_q(inputs)
};